var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'custom-checkbox',
    {
      'custom-checkbox--checked': _vm.value
    }
  ],on:{"click":_vm.toggle}},[_vm._t("icon"),(!_vm.hasSlot('icon'))?[_c('b-icon',{attrs:{"icon":_vm.icon,"scale":_vm.scale}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }